import { IPRange } from "../entity/shared/IPRange";

export function intToIP(int:number) {
  var part1 = int & 255;
  var part2 = ((int >> 8) & 255);
  var part3 = ((int >> 16) & 255);
  var part4 = ((int >> 24) & 255);

  return part4 + "." + part3 + "." + part2 + "." + part1;
}

export function ip2int(ip:string) {
  return ip.split('.').reduce(function(ipInt, octet) { return (ipInt<<8) + parseInt(octet, 10)}, 0) >>> 0;
}

export function isInRange(ipAddress:number|string, range:IPRange):boolean {
  let ipAddressNumber = typeof ipAddress === "number" ? ipAddress : ip2int(ipAddress)
  return ipAddressNumber >= range.rangeStart && ipAddressNumber <= range.rangeEnd
}